import { format } from 'date-fns';
import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { ScheduleItem } from '@/models/schedule-item.model';

class ScheduleItemsService extends BaseService {
  private url: string = '/api/schedule-item';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<ScheduleItem>> {
    const res = await this.$http.get<ScheduleItem & { date: Date }>(
      `${this.url}/${id}`,
    );
    return {
      status: res.status === Status.Ok,
      data: { ...res.data, date: format(res.data.date, 'dd-MM-yyyy') },
    };
  }

  public async getList(): Promise<DataResponse<ScheduleItem[]>> {
    const res = await this.$http.get<(ScheduleItem & { date: Date })[]>(
      `${this.url}`,
    );
    return {
      status: res.status === Status.Ok,
      data: res.data.map((d) => ({
        ...d,
        date: format(d.date, 'dd-MM-yyyy'),
      })),
    };
  }

  public async create(
    item: Partial<ScheduleItem>,
  ): Promise<DataResponse<ScheduleItem>> {
    const res = await this.$http.post<ScheduleItem>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: ScheduleItem): Promise<DataResponse<ScheduleItem>> {
    const res = await this.$http.put<ScheduleItem>(
      `${this.url}/${item.id}`,
      item,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new ScheduleItemsService();
